import React from "react";
import { FaUserCheck, FaCalendarCheck, FaStar } from "react-icons/fa";
import "../styles/Cifras.css";

const cifras = [
  {
    id: 1,
    titulo: "Cantidad de Profesionales",
    cantidad: "+200",
    icono: <FaUserCheck size={40} color="#6e3bbf" />,
  },
  {
    id: 2,
    titulo: "Pacientes Atendidos",
    cantidad: "+80.000",
    icono: <FaCalendarCheck size={40} color="#6e3bbf" />,
  },
  {
    id: 3,
    titulo: "Estrellas Promedio",
    cantidad: "4.0",
    icono: <FaStar size={40} color="#FFD700" />,
  },
];

const CifrasDestacadas = () => {
  return (
    <div className="container">
      <h2 className="text-center mb-4">CIFRAS</h2>
      {/* Contenedor con scroll horizontal */}
      <div className="cifras-scroll">
        <div className="cifras-grid">
          {cifras.map((item) => (
            <div key={item.id} className="cifra-card">
              {item.icono}
              <h3 className="cantidad">{item.cantidad}</h3>
              <p className="cifra-titulo">{item.titulo}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CifrasDestacadas;